<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    class="base__datatable"
    v-bind="[$attrs, $props]"
    v-on="$listeners"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: {
    headers: {
      type: Array
    },
    items: {
      type: Array
    },
    search: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.base__datatable 
  font-family: Poppins !important
.base__datatable.v-data-table .v-data-footer
  background-color: #FFFFFF !important
.theme--light.v-data-table .v-data-footer
  border-top: 0 !important
.theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon
  color: #059EE4 !important
.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon
  color: #2C3040 !important
.v-data-footer__icons-before .v-btn--round .v-btn__content .v-icon, .v-data-footer__icons-after .v-btn--round .v-btn__content .v-icon
  color: #2C3040
.base__datatable.v-data-table.theme--light
  box-sizing: border-box
  background-color: #E1E3E5
  padding: 0 0px
  table
    border-spacing: 0px 0px !important
    border-bottom: 2px solid #E1E3E5
  thead tr th
    background-color: #FFFFFF
    font-weight: 700
    font-size: 14px
    color: #2C3040 !important
    padding: 8px 16px
  tbody tr td
    height: 57px
    padding: 10px 10px
    font-weight: 500
    font-size: 12px
    background-color: #FFFFFF
    color: #333333
  .v-data-table__progress th
    padding-left: 0 !important
.base__datatable--border
  padding: 0 0px !important
</style>
